<div>
  {{ title }}
  <div class="input-group">
    <input
      type="text"
      class="form-control search-input"
      id="searchOrder"
      [ngClass]="{ 'remove-radius': inputSearch }"
      [(ngModel)]="inputSearch"
      (keydown.enter)="onSearch($event.target.value)"
      [placeholder]="placeholder"
      />
      <div class="input-group-append">
        @if (inputSearch) {
          <span class="input-group-text" (click)="inputSearch = null; onSearch(null)">
            <i class="fa fa-times"></i>
          </span>
        }
      </div>
    </div>
  </div>
